import { UserDetails } from 'store/signup/models';
import { createAction } from '../utils';
import {
  FETCH_ME_FAILURE,
  FETCH_ME_REQUEST,
  FETCH_ME_SUCCESS,
  FETCH_THIRD_PARTY_SSO_URL_FAILURE,
  FETCH_THIRD_PARTY_SSO_URL_REQUEST,
  FETCH_THIRD_PARTY_SSO_URL_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_MFA,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  RESET_PASSWORD_EMAIL_FAILURE,
  RESET_PASSWORD_EMAIL_REQUEST,
  RESET_PASSWORD_EMAIL_SUCCESS,
  SET_THIRD_PARTY_SSO,
  UPDATE_CURRENT_USER_PICTURE,
  UPDATE_CURRENT_USER_PREFERENCES_FAILURE,
  UPDATE_CURRENT_USER_PREFERENCES_REQUEST,
  UPDATE_CURRENT_USER_PREFERENCES_SUCCESS,
} from './constants';
import {
  FetchMeFailureAction,
  FetchMeRequestAction,
  FetchMeSuccessAction,
  FetchThirdPartySSOUrlFailureAction,
  FetchThirdPartySSOUrlRequestAction,
  FetchThirdPartySSOUrlSuccessAction,
  LoginFailureAction,
  LoginMfaAction,
  LoginRequestAction,
  LoginSuccessAction,
  LogoutFailureAction,
  LogoutRequestAction,
  LogoutSuccessAction,
  ResetPasswordEmailFailureAction,
  ResetPasswordEmailRequestAction,
  ResetPasswordEmailSuccessAction,
  SetThirdPartySSOAction,
  UpdateCurrentUserPictureAction,
  UpdateCurrentUserPreferencesFailureAction,
  UpdateCurrentUserPreferencesRequestAction,
  UpdateCurrentUserPreferencesSuccessAction,
} from './types';
import { MfaResponse, ThirdPartySSOInfo, User } from './models';
import { UserLicenceResponse } from './api';
import { Preferences } from 'shared/utils/preferences';

export const loginRequest = (
  loginParams: UserDetails,
  rememberMe?: boolean,
  gCaptchaResponse?: string,
  mfaCode?: string | null
): LoginRequestAction =>
  createAction(LOGIN_REQUEST, {
    loginParams,
    rememberMe,
    gCaptchaResponse,
    mfaCode,
  });

export const loginSuccess = (): LoginSuccessAction =>
  createAction(LOGIN_SUCCESS);

export const loginFailure = (): LoginFailureAction =>
  createAction(LOGIN_FAILURE);

export const loginMfa = (mfaResponse: MfaResponse): LoginMfaAction =>
  createAction(LOGIN_MFA, { mfaResponse });

export const fetchMeRequest = (isSessionCheck = false): FetchMeRequestAction =>
  createAction(FETCH_ME_REQUEST, { isSessionCheck });

export const fetchMeSuccess = (
  user: User,
  userLicence: UserLicenceResponse | null
): FetchMeSuccessAction =>
  createAction(FETCH_ME_SUCCESS, { user, userLicence });

export const fetchMeFailure = (): FetchMeFailureAction =>
  createAction(FETCH_ME_FAILURE);

export const logoutRequest = (): LogoutRequestAction =>
  createAction(LOGOUT_REQUEST);
export const logoutSuccess = (): LogoutSuccessAction =>
  createAction(LOGOUT_SUCCESS);
export const logoutFailure = (): LogoutFailureAction =>
  createAction(LOGOUT_FAILURE);

export const resetPasswordEmailRequest = (
  user: UserDetails
): ResetPasswordEmailRequestAction =>
  createAction(RESET_PASSWORD_EMAIL_REQUEST, { user });

export const resetPasswordEmailSuccess = (): ResetPasswordEmailSuccessAction =>
  createAction(RESET_PASSWORD_EMAIL_SUCCESS);

export const resetPasswordEmailFailure = (): ResetPasswordEmailFailureAction =>
  createAction(RESET_PASSWORD_EMAIL_FAILURE);

export const updateCurrentUserPicture = (
  picture: string
): UpdateCurrentUserPictureAction =>
  createAction(UPDATE_CURRENT_USER_PICTURE, { picture });

// Third Party SSO
export const fetchThirdPartySSOUrlRequest = (
  thirdPartySSO: ThirdPartySSOInfo
): FetchThirdPartySSOUrlRequestAction =>
  createAction(FETCH_THIRD_PARTY_SSO_URL_REQUEST, { thirdPartySSO });

export const fetchThirdPartySSOUrlSuccess =
  (): FetchThirdPartySSOUrlSuccessAction =>
    createAction(FETCH_THIRD_PARTY_SSO_URL_SUCCESS);

export const fetchThirdPartySSOUrlFailure =
  (): FetchThirdPartySSOUrlFailureAction =>
    createAction(FETCH_THIRD_PARTY_SSO_URL_FAILURE);

export const setThirdPartySSO = (
  thirdPartySSO: ThirdPartySSOInfo | undefined
): SetThirdPartySSOAction =>
  createAction(SET_THIRD_PARTY_SSO, { thirdPartySSO });

export const updateCurrentUserPreferencesRequest = (
  preferences: Preferences[]
): UpdateCurrentUserPreferencesRequestAction => {
  return createAction(UPDATE_CURRENT_USER_PREFERENCES_REQUEST, {
    preferences,
  });
};

export const updateCurrentUserPreferencesSuccess = (
  preferences: Preferences[]
): UpdateCurrentUserPreferencesSuccessAction =>
  createAction(UPDATE_CURRENT_USER_PREFERENCES_SUCCESS, {
    preferences,
  });

export const updateCurrentUserPreferencesFailure =
  (): UpdateCurrentUserPreferencesFailureAction =>
    createAction(UPDATE_CURRENT_USER_PREFERENCES_FAILURE);
